import {  TimerObservable  } from './TimerObservable';

export const timer = TimerObservable.create;


// WEBPACK FOOTER //
// ../../src/observable/timer.ts